import {
	AbstractSubmitStep,
	type AbstractSubmitStepProps,
} from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { 
	faEnvelopeCircle as fadEnvelopeCircle
 } from "@awesome.me/kit-3777c2145e/icons/duotone/solid";
import { 
	faHandshake as farHandshake
 } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { List, ProgressButton } from "bm-ui-kit";
import type { FormApi } from "final-form";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

interface StepFields {}

interface Props extends AbstractSubmitStepProps {
	pensionAmount: number;
	pensionGap: number;
}

export class Result extends AbstractSubmitStep<StepFields, Props, {}> {
	public static defaultProps = {
		canStepBack: false,
		bottomLogo: false,
		pensionAmount: 0,
		pensionGap: 0,
	};
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { submitState, pensionAmount, pensionGap } = this.props;

		return (
			<>
				<Card.Header className="bg-new-design-danger d-flex p-0 overflow-hidden top-left-shadow">
					<div className="bg-new-design-success angled-right-side p-3 top-right-shadow">
						<div className="h2 mb-1">{formatText(pensionAmount, "ft")}</div>
						<div>
							Várható havi
							<br />
							nyugdíjad
						</div>
					</div>
					<div className="py-3 pl-2">
						<div className="h2 mb-1">{formatText(pensionGap, "ft")}</div>
						<div>
							-tal kevesebb, mint a
							<br />
							jelenlegi jövedelmed
						</div>
					</div>
				</Card.Header>
				<Card.Body className="px-0 pt-0">
					<div className="d-flex p-4 mb-3 bg-dark">
						<div className="text-center my-auto ml-auto">
							<FontAwesomeIcon icon={fadEnvelopeCircle} className="duotone-success" size="5x" />
						</div>
						<div className="font-weight-bold my-auto mr-auto ml-3">
							A részletes eredményeidet emailben fogjuk elküldeni számodra!
						</div>
					</div>
					<div className="px-4">
						<div className="text-center fs-md mb-2">
							<strong>Szeretnéd megtudni:</strong>
						</div>
						<List itemStyle="tick" variant="success" size="sm" className="ml-0 mb-2">
							<List.Item>Hogy tudod pótolni a kieső összeget?</List.Item>
							<List.Item>
								Hogy milyen nyugdíj előtakarékossági megoldás a legkedvezőbb számodra?
							</List.Item>
							<List.Item>Hogy az állam mennyivel járulhat hozzá a megtakarításaidhoz?</List.Item>
						</List>
					</div>
					<div className="d-none d-sm-flex align-items-center mt-5 px-4">
						<div className="icon pr-2">
							<FontAwesomeIcon icon={farHandshake} size="2x" />
						</div>
						<div className="text-white border-left border-white pl-2 py-2">
							<strong>Bízd magad független szakértőinkre!</strong>
						</div>
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						state={submitState}
						size="lg"
						block
						className={`${!form.getState().valid ? "disabled" : ""} font-weight-bold px-2 mb-2`}
					>
						Kérem a részletes eredményem
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
